import React from "react";
import PageHeader from "../../components/PageHeader";
import BookingCreateComponent from "../../components/Booking/BookingCreate";

class BookingCreate extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Booking Create"
                            Breadcrumb={[
                                { name: "Bookings", navigate: "/booking" },
                                { name: "Booking Create", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <BookingCreateComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BookingCreate;
